import { getCSRFToken } from "../../common/Csrf"; 
import { reloadAll } from "../../common/orm";     

export const USER_DELETE_PENDING = "USER_DELETE_PENDING";
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";
export const USER_DELETE_ERROR   = "USER_DELETE_ERROR";

export const deleteUser = (userId) => async (dispatch) => {
  dispatch({ type: USER_DELETE_PENDING, userId });

  const res = await fetch("/api/delete_user/", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": getCSRFToken(),
    },
    body: JSON.stringify({ from_user_id: userId }),
  });

  if (res.status < 200 || res.status >= 300) {
    const err = (await res.text().catch(() => "")) || "Delete failed";
    dispatch({ type: USER_DELETE_ERROR, error: err, userId });
    throw new Error(err);
  }

  const data = await res.json().catch(() => ({}));
  dispatch({ type: USER_DELETE_SUCCESS, payload: data, userId });
  dispatch(reloadAll());
  return data;
};
